import {
    Box,
    Button,
    Grid,
    Paper,
    TextField,
    Typography,
    Divider,
    InputAdornment,
    Modal,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
  } from "@material-ui/core";
  import { Info, ChevronLeft } from "@material-ui/icons";
  import { makeStyles } from "@material-ui/core/styles";
  import React, { useState } from "react";
  const initialValuesFromDb ={
    "dispatchDate": {
        "value": "5-Jun-2024",
        "confidence": "95.18335723876953"
    },
    "itemNumber": {
        "value": "723650",
        "confidence": "93.30388641357422"
    },
    "lotNumber": {
        "value": "C24050",
        "confidence": "94.6102294921875"
    },
    "sealNumber": {
        "value": "96082",
        "confidence": "94.18579864501953"
    },
    "shippedQuantity": {
        "value": "3760",
        "confidence": "94.89213562011719"
    },
    "uom": {
        "value": "EA",
        "confidence": "94.52906036376953"
    },
    "storageAndShippingConditions": {
        "value": "Ambient Temperature",
        "confidence": "94.6574478149414"
    },
    "document_type": "DeliveryNote",
    "folder_name": "PCI",
    "site_name": "Dublin",
    "filename": "PCI-Dublin-DeliveryNote-45152629-C24050.pdf",
    "s3_location": "s3://bms-processed-files/PCI/Dublin/45152629-C24050/PCI-Dublin-DeliveryNote-45152629-C24050.pdf"
}
const useStyles = makeStyles((theme) => ({
    formLabel: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      minWidth: "150px",
      paddingRight: theme.spacing(2),
      textAlign: "right",
    },
    formField: {
      marginBottom: theme.spacing(2),
    },
    requiredStar: {
      color: "red",
      marginLeft: 4,
    },
  }));
function DeliveryNote(props) {
    const [isEditable, setIsEditable] = useState(false);
    const [formValues, setFormValues] = useState(initialValuesFromDb);
    const [originalValues] = useState(initialValuesFromDb);
    const [isShowingOriginal, setIsShowingOriginal] = useState(false);
    const [lastSavedValues, setLastSavedValues] = useState(initialValuesFromDb);
    const [openModal, setOpenModal] = useState(false);
    const [modalData, setModalData] = useState({
      field: "",
      before: "",
      after: "",
      updatedBy: "user123",
      timestamp: new Date().toLocaleString(),
    });
  
    const classes = useStyles();
    const fields = [
      { key: "dispatchDate", label: "Shipment Date of CMO" },
      { key: "itemNumber", label: "Consumed Batch Number" },
      { key: "lotNumber", label: "FG Batch Number" },
      { key: "sealNumber", label: "Seal Number" },
      { key: "shippedQuantity", label: "Shipped Quantity" },
      { key: "uom", label: "UoM" },
      { key: "storageAndShippingConditions", label: "Temperature Conditions" },
    ]

    const getLevelColor = (level) => {
        const num = typeof level === "string" ? parseFloat(level) : level;
        if (num < 80) return "red";
        if (num <= 90) return "orange";
        return "green";
      };
    
      const handleInputChange = (key, value) => {
        let isValid = true;

        // Inline filtering logic
        switch (key) {
         
          case "itemNumber":
          case "sealNumber":
          case "shippedQuantity":
            isValid = /^[0-9]*$/.test(value);
            break;
          case "lotNumber":
            isValid = /^[a-zA-Z0-9]*$/.test(value);
            break;
           
              case "uom":
              case "storageAndShippingConditions":
            isValid = /^[a-zA-Z]*$/.test(value);
            break;
            case "dispatchDate":
              isValid = /^(\d{0,2})?-?(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)?-?(\d{0,4})?$/i.test(value);
              break;
            
    
          
          default:
            isValid = true;
        }
    
        if (!isValid) return;
        setFormValues((prev) => ({
          ...prev,
          [key]: {
            ...prev[key],
            value: value,
          },
        }));
      };

      const isFieldChanged = (key) => {
        return formValues[key]?.value !== originalValues[key]?.value;
      };

    return (
        <div>
            <Grid container direction="column" spacing={2}>
        <Grid item container alignItems="center" spacing={2}>
          <Grid item>
            <Button
              startIcon={<ChevronLeft fontSize="small" />}
              style={{
                fontWeight: "bold",
                textTransform: "none",
                marginLeft: "0px",
              }}
            >
              Back
            </Button>
          </Grid>
          <Grid item>
            <Typography variant="h6">Digitized Delivery Note</Typography>
          </Grid>
        </Grid>

        <Grid item>
          <Divider
            style={{
              margin: "0px 0px 0px 0px",
              backgroundColor: "#707070",
              height: 1,
              zIndex: 4,
            }}
          />
        </Grid>

        <Grid item container alignItems="center">
          <Grid item>
            <Typography
              variant="h6"
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            >
              Delivery Note Data
            </Typography>
          </Grid>
          <Grid item style={{ width: "78px" }} />
          <Grid item>
            <Box display="flex" gap={5} style={{ minWidth: "340px" }}>
              <Button
                color="primary"
                variant="outlined"
                onClick={() => {
                  if (isEditable) {
                    setLastSavedValues(formValues);
                  }
                  setIsEditable((prev) => !prev);
                }}
                style={{ minWidth: 15, textAlign: "center" }}
              >
                {isEditable ? "Save Changes" : "Edit"}
              </Button>
              <Grid item style={{ width: "10px" }} />
              <Button
                color="secondary"
                variant="outlined"
                onClick={() => {
                  if (!isShowingOriginal) {
                    setFormValues(originalValues);
                  } else {
                    setFormValues(lastSavedValues);
                  }
                  setIsShowingOriginal(!isShowingOriginal);
                  setIsEditable(false);
                }}
                style={{ minWidth: 20, textAlign: "center", size: "20px" }}
              >
                {isShowingOriginal
                  ? "Show Edited Version"
                  : "Show Unedited Version"}
              </Button>
            </Box>
          </Grid>
          <Grid item style={{ width: "30px" }} />
          <Grid item>
            <Typography variant="h6">PDF Preview</Typography>
          </Grid>
        </Grid>

        <Grid item container spacing={2}>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              {fields.map((field) => (
                <Grid
                  container
                  key={field.key}
                  alignItems="center"
                  spacing={2}
                  className={classes.formField}
                >
                  <Grid item xs={4}>
                    <Typography style={{ paddingRight: 16, fontWeight: 500 }}>
                      {field.label}
                      {![
                              "Consumed Batch Number",
                              "FG Batch Number",
                              "Temperature Conditions" 
                      ].includes(field.label) && (
                        <span className={classes.requiredStar}>*</span>
                      )}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={formValues[field.key]?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.key, e.target.value)
                      }
                      onBlur={(e) => {
                        const { value } = e.target;
                        // Trim leading and trailing spaces for string values
                        if (
                          typeof value === "string" &&
                          value.trim() !== value
                        ) {
                          const trimmedValue = value.trim();
                          handleInputChange(field.key, trimmedValue);
                        }
                      }}
                      placeholder={`Enter ${field.label}`}
                      InputProps={{
                        readOnly: !isEditable,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Box display="flex" alignItems="center" pl={1}>
                              <Box
                                style={{
                                  width: 1,
                                  height: 39,
                                  backgroundColor: "#ccc",
                                  marginRight: 3,
                                }}
                              />
                              {!isEditable ? (
                                isFieldChanged(field.key)? (
                                  <Box
                                    onClick={() => {
                                      setModalData({
                                        field: field.label,
                                        before: originalValues[field.key]?.value,
                                        after: lastSavedValues[field.key]?.value,
                                        updatedBy: "user123",
                                        timestamp: new Date().toLocaleString(),
                                      });
                                      setOpenModal(true);
                                    }}
                                    style={{
                                      backgroundColor: "#7777",
                                      color: "white",
                                      borderRadius: 4,
                                      padding: "2px 8px",
                                      fontSize: "0.75rem",
                                      fontWeight: 600,
                                      minWidth: 24,
                                      textAlign: "center",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <Info fontSize="small" />
                                  </Box>
                                ) : (
                                  <Box
                                    style={{
                                      backgroundColor: getLevelColor(
                                        formValues[field.key]?.confidence
                                      ),
                                      color: "white",
                                      borderRadius: 4,
                                      padding: "2px 8px",
                                      fontSize: "0.75rem",
                                      fontWeight: 600,
                                      minWidth: 24,
                                      textAlign: "center",
                                    }}
                                  >
                                    {Math.round(
                                      formValues[field.key]?.confidence
                                    )}
                                  </Box>
                                )
                              ) : (
                                <Box
                                  style={{
                                    backgroundColor: getLevelColor(
                                      formValues[field.key]?.confidence
                                    ),
                                    color: "white",
                                    borderRadius: 4,
                                    padding: "2px 8px",
                                    fontSize: "0.75rem",
                                    fontWeight: 600,
                                    minWidth: 24,
                                    textAlign: "center",
                                  }}
                                >
                                  {Math.round(
                                    formValues[field.key]?.confidence
                                  )}
                                </Box>
                              )}
                            </Box>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              ))}

              <Box display="flex" alignItems="center" gap={2} mb={2} mt={3}>
                <Typography variant="body2" color="textSecondary">
                  Confidence Levels Legend:{" "}
                </Typography>
                <Grid item style={{ width: "28px" }} />
                <Box
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 30,
                  }}
                >
                  &gt; 90
                </Box>
                <Box
                  style={{
                    backgroundColor: "orange",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 50,
                    marginLeft: 16,
                  }}
                >
                  80 to 90
                </Box>
                <Box
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 30,
                    marginLeft: 16,
                  }}
                >
                  &lt; 80
                </Box>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              <Box
                style={{
                  height: 500,
                  backgroundColor: "#f5f5f5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px dashed #ccc",
                }}
              >
                <iframe
                  src=""
                  title="PDF Preview"
                  width="100%"
                  height="100%"
                  style={{ border: "none" }}
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Grid>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: 24,
            boxShadow: 24,
            borderRadius: 8,
            minWidth: 600,
          }}
        >
          <Typography variant="h6" gutterBottom>
            {modalData.field} - Field Data History
          </Typography>

          <Table>
            <TableHead
              style={{ border: "1px solid grey", backgroundColor: "#7777" }}
            >
              <TableRow
                style={{ border: "1px solid grey", backgroundColor: "#7777" }}
              >
                <TableCell>
                  <b>Timestamp</b>
                </TableCell>
                <TableCell>
                  <b>Before Value</b>
                </TableCell>
                <TableCell>
                  <b>After Value</b>
                </TableCell>
                <TableCell>
                  <b>Updated By</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ border: "1px solid grey" }}>
              <TableRow>
                <TableCell>{modalData.timestamp}</TableCell>
                <TableCell>{modalData.before}</TableCell>
                <TableCell>{modalData.after}</TableCell>
                <TableCell>{modalData.updatedBy}</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Box display="flex" justifyContent="center" mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenModal(false)}
            >
              OK
            </Button>
          </Box>
        </Box>
      </Modal>
    
            
        </div>
    );
}

export default DeliveryNote;